<script lang="ts">
import {Swiper, SwiperSlide } from 'swiper/vue';
import { ref } from "vue";

import {Autoplay} from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';

import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';

import '@/assets/styles/swiper.css';

// import required modules
import {Pagination, Navigation} from 'swiper/modules';
import {setup} from "vue-class-component";
const list = [
  '@/assets/images/pc/partner_1.png',
  '@/assets/images/pc/partner_2.png',
  '@/assets/images/pc/partner_5.png',
  '@/assets/images/pc/partner_4.png',
  '@/assets/images/pc/partner_3.png'
]
export default {
  components: {
    Swiper,
    SwiperSlide,
  },

  setup() {
    return {
      list,
      modules: [Pagination, Navigation, Autoplay],
    }
  }
}

</script>

<template>
  <div class="partner-box">
    <div class="big-title">
      <span>PARTNERS</span>
    </div>
    <div class="partner-swiper">
      <div class="outSwiperBox">
        <swiper
            :autoplay="{delay: 2500,stopOnLastSlide:false,disableOnInteraction: true}"
            :slides-per-view="5"
            :slides-per-group="5"
            :space-between="10"
            :loop="true"
            :navigation="{nextEl: '.swiper-button-next',prevEl: '.swiper-button-prev'}"
            :modules="modules"
            class="inSwiperBox"
        >
          <swiper-slide>
            <div class="cover-img">
              <img v-lazy="require('@/assets/images/pc/partner_1.png')" alt="">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="cover-img">
              <img v-lazy="require('@/assets/images/pc/partner_2.png')" alt="">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="cover-img">
              <img v-lazy="require('@/assets/images/pc/partner_5.png')" alt="">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="cover-img">
              <img v-lazy="require('@/assets/images/pc/partner_4.png')" alt="">
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="cover-img">
              <img v-lazy="require('@/assets/images/pc/partner_3.png')" alt="">
            </div>
          </swiper-slide>

        </swiper>
        <div class="swiper-button-prev">
          <img src="@/assets/images/pc/partner_arrowr.png" alt="">
        </div>
        <div class="swiper-button-next">
          <img src="@/assets/images/pc/partner_arrowl.png" alt="">
        </div>
      </div>

    </div>
  </div>
</template>

<style scoped lang="less">
.partner-box {
  background: #e6e6e6;
  padding: 20px 0 60px;
  .big-title {
    color: #000;
    span {
      padding: 0 40px;
      font-size: 36px;
      position: relative;
      line-height: 90px;
      height: 90px;
      display: inline-block;
      font-family: "Aleo Regular";
      &::after{
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 12px;
        background: #30affd;
        border-radius: 2px;
      }
    }

  }
  .partner-swiper {
    width: 80%;
    margin: 60px auto 0;
    .outSwiperBox {
      position: relative;
      padding: 0 14%;
      .inSwiperBox {
        height: 100px;
        margin-top: 50px;
        position: inherit;
      }
    }
    .swiper-button-prev, .swiper-button-next{
      img {
        width: 32px;
      }
    }
    .swiper-button-prev:after, .swiper-button-next:after {
      display: none;
    }
    .swiper-slide .cover-img {
      width: 100%;
      height: 98px;
      img {
        width: 85%;
        object-fit: contain;
      }
    }
  }
}
</style>